/*
 *
 *  * Copyright (c) 2020 General Electric Company. All rights reserved.
 *  *
 *  * The copyright to the computer software herein is the property of
 *  * General Electric Company. The software may be used and/or copied only
 *  * with the written permission of General Electric Company or in accordance
 *  * with the terms and conditions stipulated in the agreement/contract
 *  * under which the software has been supplied.
 *
 */
import * as _ from 'underscore';

export class DiQueue {
  messageQueue = [];
  private messageReceivedCallbacks = null;
  private _messageWaitingForResponse;

  onMessageResponseReceived(callback) {
    if (!this.messageReceivedCallbacks) {
      this.messageReceivedCallbacks = [];
    }

    const index = this.messageReceivedCallbacks.push(callback) - 1;

    return () => {
      if (!_.isArray(this.messageReceivedCallbacks)) {
        return; // someone messed with the listener array
      }

      if (this.messageReceivedCallbacks.length === 1) {
        this.messageReceivedCallbacks = null;
      } else {
        this.messageReceivedCallbacks.splice(index, 1);
      }
    };
  }

  get messageWaitingForResponse() {
    return this._messageWaitingForResponse;
  }

  set messageWaitingForResponse(value) {
    if (!value && this._messageWaitingForResponse && _.isArray(this.messageReceivedCallbacks)) {
      _.each(this.messageReceivedCallbacks, callback => {
        if (!_.isNull(callback) && !_.isUndefined(callback)) {
          callback();
        }
      });
    }
    this._messageWaitingForResponse = value;
  }
}
